<template>

    <router-view />

</template>

<script>
export default
{
    name: 'Wizard',
}
</script>


// WEBPACK FOOTER //
// Wizard.vue?5a10ccae